<template>
  <div>
    CompetitionDetailInfoLayout
  </div>
</template>

<script>
export default {
  name: "CompetitionDetailInfoLayout"
}
</script>

<style scoped>

</style>